import styled from 'styled-components';

export const ConstructionHeader = styled.header`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  justify-content: center;
  padding: 2.5rem 1.5rem 0.5rem 1.5rem;
  height: 11rem;
  margin-bottom: 0.5rem;

  & > .title {
    font-size: 1.625rem;
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: 700;
  }

  & > .subtitle {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;
